export function getPageTitle(page) {
	return page?.title || [page?.name, 'Focus Features (UK)'].filter(Boolean).join(' | ');
}

export function getPageCanonicalLink(page) {
	let url = new URL(page.path, 'https://www.focusfeaturesfilms.co.uk/');
	return url.href;
}

export function getMetaData(appData, currentPage) {
	const title = getPageTitle(currentPage);

	const defaultDescription = 'Watch trailers, book tickets, and see details of new and upcoming film releases on the official Focus Features UK website.';

	// Custom descriptions for secondary pages
	const customDescriptions = {
		about: 'Focus Features acquires and produces specialty films for the global market, and holds a library of iconic movies from fearless filmmakers.',
		contact: 'Find out how to contact Focus Features on the official Focus Features UK website.',
	};

	// Match current page id (case-insensitive)
	const pageId = currentPage?.id?.toLowerCase();
	const description = currentPage.metaDescription || customDescriptions[pageId] || defaultDescription;
	const descriptionShare = currentPage.metaDescriptionShare || description;

	const url = getPageCanonicalLink(currentPage);
	const image = currentPage.shareImage || new URL(`${__IMAGE_ROOT__}/share-default.webp`, url).href;

	let jsonSchema;
	if (currentPage.id === 'landing') {
		jsonSchema = { '@context': 'https://schema.org', '@type': 'website', name: 'Focus Features (UK)', url };
	}

	return {
		title,
		image,
		url,
		description,
		tags: [
			{ name: 'description', content: description },
			{ name: 'twitter:title', content: title },
			{ name: 'twitter:image', content: image },
			{ name: 'twitter:description', content: descriptionShare },
			// { name: 'google-site-verification', content: '_BWnI3vobObTPCauutH6jt2KKYDkuwMHtoyaV3M0H0Q' },
			{ property: 'og:site_name', content: 'Focus Features (UK)' },
			{ property: 'og:title', content: title },
			{ property: 'og:image', content: image },
			{ property: 'og:width', content: '1200' },
			{ property: 'og:height', content: '630' },
			{ property: 'og:description', content: descriptionShare },
			{ property: 'og:url', content: url },
		],
		jsonSchema,
	};
}
